"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStylesTabs = exports.useStylesTab = void 0;
var _styles = require("@material-ui/styles");
var useStylesTabs = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderBottom: "2px solid ".concat(theme.palette.NEUTRAL030),
      minHeight: 32
    },
    indicator: {
      backgroundColor: theme.palette.BLUE400
    }
  };
});
exports.useStylesTabs = useStylesTabs;
var useStylesTab = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      textTransform: 'none',
      minWidth: 72,
      minHeight: 32,
      color: theme.palette.NEUTRAL500,
      opacity: 1,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      marginRight: 0,
      '&:hover': {
        color: theme.palette.BLUE400,
        opacity: 1
      },
      '&$selected': {
        color: theme.palette.BLUE400,
        fontWeight: theme.typography.fontWeightMedium
      },
      '&:focus': {
        color: theme.palette.BLUE400
      }
    },
    selected: {}
  };
});
exports.useStylesTab = useStylesTab;